















































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import { GetContractDocumentAsReqBody } from "@/models/app-api";
import XDialog from "../SimpleDialog.vue";
import { documentGetterForm } from "@/assets/scripts/form-fields/main";
import AppApiMixin from "../mixins/AppApi.vue";
import DocGetterMixin from "../mixins/DocGetter.vue";

const { values, attrs, errors, validations } = documentGetterForm;

@Component({
  components: { XDialog },
  mixins: [validationMixin],
  computed: {
    ...errors,
    ...mapGetters({ contractId: "contract/id", userEmail: "user/email" }),
  },
  validations,
})
class ContractDocGetterDialog extends Mixins(AppApiMixin, DocGetterMixin, XDialog) {
  [x: string]: any;

  @Prop({ required: true }) readonly showDialog!: boolean;
  @Prop({ required: true }) readonly docId!: number;
  @Prop() readonly docName!: string;
  @Prop({ default: false }) readonly isSendMode!: boolean;
  @Prop({ default: false }) readonly isEdoMode!: boolean;

  values = { email: values.email };
  allFieldAttrs = {
    email: attrs.email,
  };

  useAgreeButtonLoading = false;
  submitErrorText = "";

  public get itemTexts() {
    return this.isSendMode
      ? { dialogTitle: "Отправить документ на email", agreeButton: "Отправить" }
      : { dialogTitle: "Скачать документ", agreeButton: "Скачать" };
  }

  public get fields() {
    return this.isSendMode ? this.allFieldAttrs : null;
  }

  @Watch("showDialog")
  public showDialogChanged() {
    if (this.showDialog) {
      this.values.email = this.userEmail;

      return;
    }

    this.values.email = "";
    this.submitErrorText = "";

    this.$v.$reset();
  }

  public onAgree(evt: { name: string; payload: null }) {
    this.submitErrorText = "";
    this.useAgreeButtonLoading = true;

    const { isSendMode, propagateCustomEvt, values } = this;

    const reqBody: GetContractDocumentAsReqBody = {
      documentId: this.docId,
    };
    if (isSendMode) {
      reqBody.emailSend = true;
      reqBody.email = values.email;
    } else {
      reqBody.download = true;
    }

    if (this.isEdoMode) {
      // Загрузка файла ЭДО
      this.getContractDocumentEdoByContract(reqBody)
        .then((response) => {
          if (!isSendMode) {
            this.downloadDocument(response);
            return propagateCustomEvt(evt.name);
          }
          propagateCustomEvt(evt.name, values.email);
        })
        .catch((_) => (this.submitErrorText = "Непредвиденная ошибка"))
        .finally(() => (this.useAgreeButtonLoading = false));
    } else {
      // Загрузка обычного файла
      this.getContractDocumentByContract(reqBody)
        .then((response) => {
          if (!isSendMode) {
            this.downloadDocument(response);
            return propagateCustomEvt(evt.name);
          }
          propagateCustomEvt(evt.name, values.email);
        })
        .catch((_) => (this.submitErrorText = "Непредвиденная ошибка"))
        .finally(() => (this.useAgreeButtonLoading = false));
    }
  }
}

export default ContractDocGetterDialog;
